(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62176],{

/***/ 87752:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin",
      function () {
        return __webpack_require__(12854);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Alert(param) {
    var children = param.children, className = param.className, type = param.type, open = param.open, setOpen = param.setOpen;
    var typeIcon = function(type) {
        switch(type){
            case "warning":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"
                    })
                });
            case "error":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z"
                    })
                });
            case "success":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"
                    })
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
                    })
                });
        }
    };
    var typeColor = function(type) {
        switch(type){
            case "warning":
                return "bg-yellow-100 border-yellow-200 text-yellow-600";
            case "error":
                return "bg-red-100 border-red-200 text-red-600";
            case "success":
                return "bg-green-100 border-green-200 text-green-600";
            default:
                return "bg-indigo-100 border-indigo-200 text-indigo-500";
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open) {
            var timer = setTimeout(function() {
                setOpen(false);
            }, 2500);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-4 py-2 rounded-sm text-sm border ".concat(typeColor(type)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full justify-between items-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex",
                            children: [
                                typeIcon(type),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: children
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "opacity-70 hover:opacity-80 ml-3 mt-[3px]",
                            onClick: function() {
                                return setOpen(false);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "sr-only",
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "w-4 h-4 fill-current",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Alert);


/***/ }),

/***/ 86707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Button_loading = function(param) {
    var text_color = param.text_color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "animate-spin -ml-1 mr-3 h-5 w-5 ".concat(text_color),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button_loading);


/***/ }),

/***/ 25470:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Google = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-wrap -mx-3",
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full px-3",
            children: /*#__PURE__*/ _jsxs("button", {
                className: "btn px-0 text-white bg-red-600 hover:bg-red-700 w-full relative flex items-center",
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        className: "w-4 h-4 fill-current text-white opacity-75 flex-shrink-0 mx-4",
                        viewBox: "0 0 16 16",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M7.9 7v2.4H12c-.2 1-1.2 3-4 3-2.4 0-4.3-2-4.3-4.4 0-2.4 2-4.4 4.3-4.4 1.4 0 2.3.6 2.8 1.1l1.9-1.8C11.5 1.7 9.9 1 8 1 4.1 1 1 4.1 1 8s3.1 7 7 7c4 0 6.7-2.8 6.7-6.8 0-.5 0-.8-.1-1.2H7.9z"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "flex-auto pl-16 pr-8 -ml-16",
                        children: "Continue with Google"
                    })
                ]
            })
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Google)));


/***/ }),

/***/ 12854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Auth_Sign_in__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90036);
/* harmony import */ var _utils_discourse_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65233);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var _api_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10107);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60538);
/* harmony import */ var _utils_tradly_integration_auth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20435);












// import Header from "../partials/Header";
function SignIn(param) {
    var isLoggedIn = param.isLoggedIn, isEmailVerified = param.isEmailVerified;
    var ref, ref1, ref2;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var redirect_url = router.query.to || constant_url__WEBPACK_IMPORTED_MODULE_3__.default_site_url;
    var sso = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.sso) || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.payload);
    var sig = router.query.sig;
    var identifier = router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.identity;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), is_log_in_by_discourse = ref3[0], setISlogInByDiscourse = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), is_log_in_by_tradly_integration = ref4[0], setISlogInByTradlyIntegration = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        if (!isLoggedIn && sso && sig && identifier === "tradly") {
            setISlogInByTradlyIntegration(true);
        } else if (!isLoggedIn && sso && sig && (identifier !== "tradly" || identifier === undefined)) {
            setISlogInByDiscourse(true);
        } else if (isLoggedIn && sso && sig) {
            var auth_key = (0,constant_functions__WEBPACK_IMPORTED_MODULE_10__.getAuthKey)();
            if (identifier === undefined) {
                (0,_api_api__WEBPACK_IMPORTED_MODULE_9__/* .getUserDetails */ .M_)(auth_key).then(function(res) {
                    if (res === null || res === void 0 ? void 0 : res.user) {
                        (0,_utils_discourse_auth__WEBPACK_IMPORTED_MODULE_2__/* .discourse_redirect */ .kM)({
                            sso: sso,
                            sig: sig,
                            user: res === null || res === void 0 ? void 0 : res.user,
                            router: router
                        });
                    } else {
                        router.push(redirect_url);
                    }
                }).catch(function(error) {
                    router.push(redirect_url);
                });
            } else if (identifier === "tradly") {
                (0,_api_api__WEBPACK_IMPORTED_MODULE_9__/* .getUserDetails */ .M_)(auth_key).then(function(res) {
                    if (res === null || res === void 0 ? void 0 : res.user) {
                        (0,_utils_tradly_integration_auth__WEBPACK_IMPORTED_MODULE_11__/* .tradly_integration_redirect */ .we)({
                            sso: sso,
                            sig: sig,
                            user: res === null || res === void 0 ? void 0 : res.user,
                            router: router
                        });
                    } else {
                        router.push(redirect_url);
                    }
                }).catch(function(error) {
                    router.push(redirect_url);
                });
            }
        } else if (isLoggedIn && !isEmailVerified) {
            router.push("/verify_email?to=".concat(redirect_url));
        } else if (isLoggedIn && isEmailVerified) {
            router.push(redirect_url);
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Tradly - Signin"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col min-h-screen overflow-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                    className: "flex-grow",
                    children: is_log_in_by_discourse ? (0,_utils_discourse_auth__WEBPACK_IMPORTED_MODULE_2__/* .check_discourse_payload */ .wL)({
                        component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Auth_Sign_in__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            sso: sso,
                            sig: sig,
                            is_log_in_by_discourse: is_log_in_by_discourse
                        }),
                        sso: sso,
                        sig: sig
                    }) : is_log_in_by_tradly_integration ? (0,_utils_tradly_integration_auth__WEBPACK_IMPORTED_MODULE_11__/* .check_tradly_auth_integration_payload */ .K4)({
                        component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Auth_Sign_in__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            sso: sso,
                            sig: sig,
                            is_log_in_by_tradly_integration: is_log_in_by_tradly_integration
                        }),
                        sso: sso,
                        sig: sig
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Auth_Sign_in__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        sso: sso,
                        sig: sig,
                        isLoggedIn: isLoggedIn
                    })
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (SignIn);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [33714,87536,26281,88000,90036,49774,92888,40179], function() { return __webpack_exec__(87752); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);